import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { message, Select } from "antd";
import { DropdownSuffix } from "icons";
import { useEffect, useState } from "react";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { useCurrentUserContext } from "providers";

export const UpdateCaseStatus = ({
  caseTotalStatuses,
  caseStatus,
  caseStatusLocal,
  setCaseStatusLocal,
  className,
  refetchDetail,
}) => {
  const { caseId } = useParams();
  const { translator } = useLanguageTranslator();
  const { user } = useCurrentUserContext();

  const [
    updateStatus,
    {
      data: updateStatusData,
      isLoading: updateStatusLoading,
      error: updateStatusErr,
    },
  ] = UseLazyApiCallV2({
    url: "/update_status",
    method: "POST",
  });

  async function handleSelectStatus(statusId) {
    setCaseStatusLocal(statusId);
    const params = {
      case_id: caseId,
      statusId,
      loggedUser: user?.email,
    };

    try {
      const res = await updateStatus({
        params,
      });

      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        refetchDetail();
      }
    } catch (error) {
      console.log({ error });
    }
  }

  const statusDropdownData = caseTotalStatuses?.map((item) => ({
    label: item?.settingName,
    value: item?.settingId,
  }));

  return (
    <div className={`${styles.statusUpdate} ${className}`}>
      <div className={styles.label}>{translator("caseStatus")}:</div>
      <div className={`${styles.dropdown} ${styles?.[caseStatus]}`}>
        <Select
          dropdownStyle={{ minWidth: "250px" }}
          defaultValue={caseStatus}
          value={caseStatus}
          style={{
            width: "140px",
            height: "4.3dvh",
          }}
          onSelect={handleSelectStatus}
          options={statusDropdownData}
          suffixIcon={<DropdownSuffix />}
        />
      </div>
    </div>
  );
};
